import React from "react";
import { Loader2 } from "lucide-react";
import { useDynamicLoader } from "../../hooks/useDynamicLoader";
import "./LoadingState.css";

type Props = {
  isLoading: boolean;
  messages?: readonly string[];
  label?: string;
  spinnerSize?: number;
  intervalMs?: number;
};

// Hoisted so the default prop is a stable reference across renders (avoids the
// unstable-default-props lint and needless effect re-runs in useDynamicLoader).
const DEFAULT_MESSAGES: readonly string[] = ["Loading…"];

export default function LoadingState({
  isLoading,
  messages = DEFAULT_MESSAGES,
  label = "Loading",
  spinnerSize = 32,
  intervalMs = 1200,
}: Props) {
  const text = useDynamicLoader(messages, isLoading, { intervalMs });

  if (!isLoading) return null;

  return (
    <div className="loadingState" role="status" aria-live="polite" aria-label={label}>
      <Loader2 className="loadingState__spinner" size={spinnerSize} aria-hidden="true" />
      <p className="loadingState__text">{text}</p>
    </div>
  );
}
